<app-module-header
  [title]="(organization? $safeNavigationMigration(organization?.organizationName)+ ' - ' : '') + ('FLIGHT.DEPARTURE.DEPARTURES' | transloco) + ' / ' + ('FLIGHT.ARRIVAL.ARRIVALS' | transloco)"
[icon]="'connecting_airports'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="container-fluid my-2">
  <mat-tab-group dynamicHeight syncTabsWithUrl>
    <mat-tab [label]="'FLIGHT.DEPARTURE.DEPARTURES' | transloco" urlKey="departures">
      <app-departure-list [isLoading]="isLoading" (incrementRequests)="incrementRequests()"
      (decrementRequests)="decrementRequests()"></app-departure-list>
    </mat-tab>
    <mat-tab [label]="'FLIGHT.ARRIVAL.ARRIVALS' | transloco" urlKey="arrivals">
      <app-arrival-list [isLoading]="isLoading" (incrementRequests)="incrementRequests()"
      (decrementRequests)="decrementRequests()"></app-arrival-list>
    </mat-tab>
  </mat-tab-group>
</div>
